/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AnswersJobAnswer } from '../models/answers-job-answer';
import { Envelope } from '../models/envelope';
@Injectable({
  providedIn: 'root',
})
class AnswerService extends __BaseService {
  static readonly AnswerGetAllPath = '/api/Answer';
  static readonly AnswerUpdatePath = '/api/Answer';
  static readonly AnswerCreatePath = '/api/Answer';
  static readonly AnswerGetPath = '/api/Answer/{id}';
  static readonly AnswerDeletePath = '/api/Answer/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  AnswerGetAllResponse(): __Observable<__StrictHttpResponse<Envelope<AnswersJobAnswer[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Answer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AnswersJobAnswer[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  AnswerGetAll(): __Observable<Envelope<AnswersJobAnswer[]>> {
    return this.AnswerGetAllResponse().pipe(
      __map(_r => _r.body as Envelope<AnswersJobAnswer[]>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  AnswerUpdateResponse(entity: AnswersJobAnswer): __Observable<__StrictHttpResponse<Envelope<AnswersJobAnswer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Answer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AnswersJobAnswer>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  AnswerUpdate(entity: AnswersJobAnswer): __Observable<Envelope<AnswersJobAnswer>> {
    return this.AnswerUpdateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<AnswersJobAnswer>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  AnswerCreateResponse(entity: AnswersJobAnswer): __Observable<__StrictHttpResponse<Envelope<AnswersJobAnswer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Answer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AnswersJobAnswer>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  AnswerCreate(entity: AnswersJobAnswer): __Observable<Envelope<AnswersJobAnswer>> {
    return this.AnswerCreateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<AnswersJobAnswer>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  AnswerGetResponse(id: number): __Observable<__StrictHttpResponse<Envelope<AnswersJobAnswer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Answer/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AnswersJobAnswer>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  AnswerGet(id: number): __Observable<Envelope<AnswersJobAnswer>> {
    return this.AnswerGetResponse(id).pipe(
      __map(_r => _r.body as Envelope<AnswersJobAnswer>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  AnswerDeleteResponse(id: number): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Answer/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  AnswerDelete(id: number): __Observable<Envelope<any>> {
    return this.AnswerDeleteResponse(id).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }
}

module AnswerService {
}

export { AnswerService }
